
import React from 'react';
import { DeepAnalysisResult, BonusSection } from '@/types/analysisTypes';
import { BonusInsightsDisplayProps } from './bonus-insights/types';
import { hasContent } from './bonus-insights/utils';
import { BonusInsightItem } from './bonus-insights/BonusInsightItem';
import { EmptyState } from './bonus-insights/EmptyState';

export const BonusInsightsDisplay: React.FC<BonusInsightsDisplayProps> = ({
  pageAnalysisResult
}) => {
  const [openItem, setOpenItem] = React.useState<string | null>(null);

  const toggleItem = (item: string) => {
    setOpenItem(openItem === item ? null : item);
  };

  // Check if bonus section exists and has content
  if (!pageAnalysisResult?.bonus_section || 
      Object.keys(pageAnalysisResult.bonus_section).length === 0) {
    return <EmptyState />;
  }

  // Debug output to console for troubleshooting
  console.log('Bonus section content:', pageAnalysisResult.bonus_section);
  
  // Get the bonus section
  const bonusSection = pageAnalysisResult.bonus_section;

  // Filter out sections with no content
  const insightKeys = ['expert_insight', 'unexpected_analogy', 'challenged_assumption', 'insider_tip'].filter(key => 
    bonusSection[key as keyof typeof bonusSection] && hasContent(key, bonusSection)
  );

  // If no valid sections, show empty state
  if (insightKeys.length === 0) {
    return <EmptyState />;
  }

  return (
    <div className="space-y-4 mt-4">
      <h4 className="text-md font-medium">Creative Insights</h4>
      
      <div className="space-y-3">
        {insightKeys.map((key) => (
          <BonusInsightItem 
            key={key}
            insightKey={key}
            bonusSection={bonusSection}
            openItem={openItem}
            toggleItem={toggleItem}
          />
        ))}
      </div>
    </div>
  );
};
